<template>
  <div>

    <v-dialog persistent v-if="dialogyetki" v-model="dialogyetki" max-width="500px">
      <v-card flat color="grey lighten-5">

        <v-flex pa-1 xs12 sm12 md12>
          <v-card flat>
            <v-layout row wrap>
              <v-flex md10 pt-2 pl-2 xs10 sm10>
                <v-textarea  hide-details id="js-copytextarea" rows="2" no-resize v-model="LinkKod"></v-textarea>
              </v-flex>
              <v-flex pt-4 md2 xs2 sm2>
                <v-layout row justify-center>
                  <v-icon @click="kopyala()" large color="grey">file_copy
                  </v-icon>

                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn color="green"  flat @click="git()">Siteye Git</v-btn>
          <v-btn color="info" flat @click="Iptal()">{{$t('Close')}}</v-btn>

          <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>




    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"


  export default {
    props: ["value"],
    components: {

    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    methods: {
        git() {
        var url = this.LinkKod
        window.open(url, '_blank')
      },
      kopyala() {

        var copyText = document.getElementById("js-copytextarea");
        copyText.select();
        document.execCommand("copy");
      },

      Iptal() {
        this.resolve(false);
        this.dialogyetki = false
      },

      open(mesaj) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params3 = {
          CompanyCode: credentials.SirketKodu
        }

        var params = {
          MusteriKodu: credentials.AnaSirketKodu,
          CariKodu: null,
          Dot9Sifre: null,
        }

        this.$http.post(auth.API_URL + 'api/Dot9/GetReportLink', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
         //this.LinkKod = 'http://getreport.kunet.com.tr/#/login/' + response.body.LinkKod
         this.LinkKod = 'https://getreportv2.arkman.com.tr/#/login/' + response.body.LinkKod
         //this.LinkKod =  'http://getreport.dessin.net/#/login/' // dessin
         //this.LinkKod = 'http://getreport.freebirdtravel.com/#/login/' + response.body.LinkKod
         //this.LinkKod = 'https://getreport.akyakatur.com.tr/#/login/' + response.body.LinkKod
         //this.LinkKod = 'http://192.168.0.8:8070/#/login/' + response.body.LinkKod //vizyon turizm
         //this.LinkKod = 'http://192.168.1.105:8092/#/login/' + response.body.LinkKod // ritmix-profit turizm
         //this.LinkKod = 'https://getreport.ucbilet.com/' // geziburda  TUR
         //this.LinkKod = 'https://getreport.biletsepeti.com/' // biletsepeti  TUR
         //this.LinkKod = 'https://getreport-stage.biletsepeti.com/' // biletsepeti  stage TUR
         //this.LinkKod = 'http://getreport.cappadocetour.com/#/login/' //cappadoce
         //this.LinkKod = 'http://getreport.turplus.com.tr:8070/#/login/' + response.body.LinkKod   // TURPLUS TURIZM
         //this.LinkKod = 'https://getreport.shallwego.com/#/login/' + response.body.LinkKod
         //this.LinkKod = 'http://getreport.gezinomi.com/#/login/' + response.body.LinkKod
       //  this.LinkKod = 'http://getreport.antur.com.tr/#/login/' + response.body.LinkKod
         //this.LinkKod = 'http://getreport.sampa.com/#/login/' + response.body.LinkKod
         //this.LinkKod = 'http://getreport.mngtour.com/#/login/' + response.body.LinkKod
         //this.LinkKod = 'http://172.20.1.54:8070/#/login/' + response.body.LinkKod //pronto yeni
         //this.LinkKod = 'http://localhost:8082/#/login/' + response.body.LinkKod //easytravel
         //this.LinkKod = 'https://getreport.arkas.com:443/#/login/' + response.body.LinkKod
         //this.LinkKod = 'https://getreport.bekturizm.com/#/login/' + response.body.LinkKod
         //this.LinkKod = 'https://getreport.msctr.com:443/#/login/' + response.body.LinkKod   //cisalpına
         //this.LinkKod = 'http://getreport.polsan.com.tr/#/login/' + response.body.LinkKod
         //this.LinkKod = 'http://192.168.0.8:8090/#/login/' + response.body.LinkKod //gazella
         //this.LinkKod = 'https://nextarkman.visa34.com/#/login/' + response.body.LinkKod //hermes
         //this.LinkKod = 'http://getreport.superpay.tech/#/login/' + response.body.LinkKod
         //this.LinkKod = 'http://getreport.dorak.com/#/login/' + response.body.LinkKod
         //this.LinkKod = 'http://172.31.10.178:8090/#/login/' + response.body.LinkKod //GAZI GLOBAL
         //this.LinkKod = 'https://arkmanreport-tst.yasar.net/#/login/' + response.body.LinkKod  //BINTUR
         //this.LinkKod = 'https://arkmanreport.yasar.net/#/login/' + response.body.LinkKod  //BINTUR LIVE
         //this.LinkKod = 'http://192.168.1.253:8082/#/login/' + response.body.LinkKod //gazella
         //this.LinkKod = 'http://getreport.entas.com.tr/#/login/' + response.body.LinkKod  // ENTAS 

         

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

        this.dialogyetki = true;

        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
    },
    data() {
      return {
        LinkKod: null,

        bekle: false,
        islem: 0,
        sozlesmeOnay: false,
        mesaj: null,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        dialogyetki: false,
        k: null,
        doviztipi: [],
        reject: null,
        tahsilatdialog: false,
        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },


    watch: {

    },
  }




  function beforeMount() {

  }
</script>
<style>
  header {
    font-family: 'Lobster', cursive;
    text-align: center;
    font-size: 25px;
  }

  #info {
    font-size: 18px;
    color: #555;
    text-align: center;
    margin-bottom: 25px;
  }

  a {
    color: #074E8C;
  }

  .scrollbar {
    margin-left: 10px;
    float: left;
    height: 300px;
    width: 100%px;
    background: rgb(255, 255, 255);
    overflow-y: scroll;
    margin-bottom: 25px;
  }

  .force-overflow {
    min-width: 800px;
  }

  #wrapper {
    text-align: center;
    width: 500px;
    margin: auto;
  }

  /*
 *  STYLE 1
 */

  #style-1::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  #style-1::-webkit-scrollbar {
    width: 12px;
    background-color: #F5F5F5;
  }

  #style-1::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: royalblue;
  }
</style>